import { Injectable } from '@angular/core';
import { Observable, Subject } from  "rxjs";
import { HttpHeaders, HttpClient } from '@angular/common/http';
//import { AuthService } from '@shared/services/Auth/auth.service';
//import { ConstantsService } from '@shared/services/Constants/constants.service';
//import { ManualEntry } from '@shared/classes/manualEntry';
import { map } from 'rxjs/operators';
import { AuthService } from './Auth/auth.service';
import { ConstantsService } from './Constants/constants.service';

@Injectable({
  providedIn: 'root'
})
export class AuditTrailService {
  private _refreshPage = new Subject<void>();
  private _resetFilters = new Subject<void>();
  private _resetHeaders = new Subject<void>();
  private _refreshwithFilters = new Subject<void>();
  private service_URL: any;
  get refreshPage()
  {
     return this._refreshPage;
  }

  get resetFilters()
  {
     return this._resetFilters;
  }

  get resetHeaders()
  {
     return this._resetHeaders;
  }
  get refreshwithFilters()
  {
     return this._refreshwithFilters;
  }

  constructor(private httpClient: HttpClient, private authService: AuthService) {
    this.service_URL = ConstantsService;
  }
  globalHeaders(): any {
      let headers: HttpHeaders = new HttpHeaders();
      headers.append('Content-Type', 'application/json');
      headers.append('Access-Control-Allow-Origin', '*');
      headers.append('Access-Control-Allow-Methods', 'GET,PUT,POST,DELETE');
      headers.append('Access-Control-Allow-Headers', 'Content-Type');
      let options = { headers: headers };
      return options;
  
    }
}

